import { useQuery } from 'react-query';
import { CheckoutAPI } from 'api/checkout';
import { CHECKOUT } from 'helpers/constants';

export default function useCheckout() {
  return useQuery(CHECKOUT, CheckoutAPI.getCheckoutInfo);
}
